import { createContext, useContext, useMemo } from 'react';
import { _animateTypes, _dimmerTypes } from '../../motions/AnimateComponent';
import { animationVariants } from '../../motions/animationVariants';
import { HomeSettingsContext } from './SettingsDataContext';

export const TransitionContext = createContext();

const TransitionProvider = (props) => {

  const homeSettingsContext = useContext(HomeSettingsContext)

  const { homeSettings_state } = homeSettingsContext ?? {}
  const { homeSettings } = homeSettings_state ?? {}
  const { global: global_h } = homeSettings ?? {}
  const { transitionItems, dimmerItems } = global_h ?? {}

  const transitions = useMemo(() => {
    if (!transitionItems) return {};
    return Object.keys(_animateTypes).reduce((acc, at) => {
      const { variants, useTransitions } = animationVariants(at, transitionItems);
      acc[at] = { animateType: at, variants, showTransition: useTransitions };
      return acc;
    }, {});
  }, [transitionItems]);

  const dimmers = useMemo(() => {
    if (!dimmerItems) return {};
    return _.reduce(_dimmerTypes, (acc, _, dt) => {
      const di = dimmerItems[dt];
      acc[dt] = { ...di, dimmerType: dt };
      return acc;
    }, {});
  }, [dimmerItems]);

  return transitions ? <TransitionContext.Provider value={{ transition_state: { transitions, dimmers } }} >
    {props.children}
  </TransitionContext.Provider> : <div></div>

};

export default TransitionProvider 